import { TENANT_ID } from "./api-factory"
const POST_HEADER = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    
}
const TENANT_POST_HEADER = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'X-Tenant-ID':TENANT_ID
}
const MULTIPART_TENANT_POST_HEADER = {
    'Accept': 'application/json',
    'Content-Type': 'multipart/form-data',
    'X-Tenant-ID':TENANT_ID
}
const TENANT_BRE_POST_HEADER = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'X-Tenant-ID':TENANT_ID
}

const GET_HEADER = {
    
}
const TENANT_HEADER = {
    headers:{
        'X-Tenant-ID':TENANT_ID
    }
}

export {
    TENANT_POST_HEADER,
    POST_HEADER,
    GET_HEADER,
    TENANT_HEADER,
    TENANT_BRE_POST_HEADER,
    MULTIPART_TENANT_POST_HEADER
}